import * as structureType from "../../action/actiontype/StrutureType/StrutureType";

const structureReducer = (state = {}, action) => {
    switch (action.type) {
        // Structure List

        case structureType.STRUCTURE_REQUEST_LIST:
            return {
                ...state,
                structureListLoading: true,
                structureListResponse: {},
                structureListError: null
            }
        case structureType.STRUCTURE_SUCCESS_LIST:
            return {
                ...state,
                structureListLoading: false,
                structureListResponse: action.payload,
                structureListError: null
            }
        case structureType.STRUCTURE_FAILURE_LIST:
            return {
                ...state,
                structureListLoading: false,
                structureListResponse: {},
                structureListError: action.payload
            }

             // GetById
    case structureType.STRUCTURE_REQUEST_GETBYID:
        return {
          ...state,
          structureGetIdLoading: true,
          structureGetIdResponse: {},
          structureGetIdError: null,
        };
      case structureType.STRUCTURE_SUCCESS_GETBYID:
        return {
          ...state,
          structureGetIdLoading: false,
          structureGetIdResponse: action.payload,
          structureGetIdError: null,
        };
      case structureType.STRUCTURE_FAILURE_GETBYID:
        return {
          ...state,
          structureGetIdLoading: false,
          structureGetIdResponse: {},
          structureGetIdError: action.payload,
        };
        //update
      case structureType.STRUCTURE_REQUEST_UPDATE:
        return {
          ...state,
          structureUpdateLoading: true,
          structureUpdateResponse: {},
          structureUpdateError: null,
        };
      case structureType.STRUCTURE_SUCCESS_UPDATE:
        return {
          ...state,
          structureUpdateLoading: false,
          structureUpdateResponse: action.payload,
          structureUpdateError: null,
        };
      case structureType.STRUCTURE_FAILURE_UPDATE:
        return {
          ...state,
          structureUpdateLoading: false,
          structureUpdateResponse: {},
          structureUpdateError: action.payload,
        };

        //ADD Contact
        case structureType.STRUCTURE_REQUEST_ADD: 
          return {
            ...state,
            structureContactLoading:true,
            structureContactResponse:{},
            structureContactError:null,

          };
        case structureType.STRUCTURE_SUCCESS_ADD:
          return {
            ...state,
            structureContactLoading:false,
            structureContactResponse:action.payload,
            structureContactError:null,
          };
        case structureType.STRUCTURE_FAILURE_ADD:
          return {
            ...state,
            structureContactLoading:false,
            structureContactResponse:{},
            structureContactError:action.payload,
          };

          //DELETE
        case structureType.STRUCTURE_REQUEST_DELETE:
          return {
            ...state,
            structureDeleteLoading:true,
            structureDeleteResponse:{},
            structureDeleteError:null,

          };
        case structureType.STRUCTURE_SUCCESS_DELETE:
          return {
            ...state,
            structureDeleteLoading:false,
            structureDeleteResponse:action.payload,
            structureDeleteError:null,
          };
        case structureType.STRUCTURE_FAILURE_DELETE:
          return {
            ...state,
            structureDeleteLoading:false,
            structureDeleteResponse:{},
            structureDeleteError:action.payload,
          };
          // update Contact
          case structureType.STRUCTURE_REQUEST_CONTACTUPDATE:
        return {
          ...state,
          structureContactUpdateLoading: true,
          structureContactUpdateResponse: {},
          structureContactUpdateError: null,
        };
      case structureType.STRUCTURE_SUCCESS_CONTACTUPDATE:
        return {
          ...state,
          structureContactUpdateLoading: false,
          structureContactUpdateResponse: action.payload,
          structureContactUpdateError: null,
        };
      case structureType.STRUCTURE_FAILURE_CONTACTUPDATE:
        return {
          ...state,
          structureContactUpdateLoading: false,
          structureContactUpdateResponse: {},
          structureContactUpdateError: action.payload,
        };

        case structureType.STRUCTURE_PREV_ID:
          return {
            ...state,
            structurePreviousSelectedId :action.payload
          };

        default:
            return state;
    }
}

export default structureReducer;